import { useState } from 'react';
import { Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router';

// Tecton
import FeatureViewMonitoring from './FeatureViewMonitoring';
import {
  MonitoringFeatureServiceRoutes,
  MonitoringRoutes,
  getMonitoringFeatureServiceGroupRoutes,
  getMonitoringRouteName,
} from './monitoringUtils';
import StreamIngestMonitoring from './StreamIngestMonitoring';

// @tecton
import { ViewLayout } from '@lithos';
import { useUserSettings } from '../../context/UserSettingsContext';
import RealtimeServerMonitoring from './RealtimeServerMonitoring';

const MonitoringContainerOutlet = () => {
  /*
    This contains the header portion of the Feature view
    - Breadcrumbs
    - Tabs
    - Outlet to the content
  */

  const navigation = useNavigate();

  const location = useLocation();
  const featureRoutes = getMonitoringRouteName(location.pathname);
  const [selectedTab, setSelectedTab] = useState<MonitoringRoutes | MonitoringFeatureServiceRoutes>(featureRoutes);

  const routeNames = Object.keys(getMonitoringFeatureServiceGroupRoutes());

  return (
    <ViewLayout
      header={{
        title: 'Monitoring',
        breadcrumbs: {
          root: { label: 'Monitoring', url: '/monitoring' },
          items: [],
        },
        tabs: {
          selectedTab: selectedTab,
          items: routeNames.map((routeName) => ({ label: routeName, value: routeName })),
          setSelectedTab: (tab: MonitoringFeatureServiceRoutes) => {
            const routes = getMonitoringFeatureServiceGroupRoutes();
            navigation(routes[tab]);
            setSelectedTab(tab);
          },
        },
      }}
      content={
        <div style={{ height: '100%' }}>
          <Outlet />
        </div>
      }
    />
  );
};

const MonitoringContainer = () => {
  const { isStreamingIngestEnabled } = useUserSettings();

  const monitoringRoutes = getMonitoringFeatureServiceGroupRoutes();
  return (
    <Routes>
      <Route element={<MonitoringContainerOutlet />}>
        <Route index element={<Navigate to={monitoringRoutes[`Feature View`]} replace />} />
        <Route path={monitoringRoutes[`Feature View`]} element={<FeatureViewMonitoring />} />
        <Route path={monitoringRoutes[`Server Groups`]} element={<RealtimeServerMonitoring />} />
        {isStreamingIngestEnabled && (
          <Route path={monitoringRoutes[`Stream Ingest`]} element={<StreamIngestMonitoring />} />
        )}
      </Route>
    </Routes>
  );
};

export default MonitoringContainer;
